import { render } from "./MdCard.vue?vue&type=template&id=6d9a965d&scoped=true&ts=true"
import script from "./MdCard.vue?vue&type=script&lang=ts"
export * from "./MdCard.vue?vue&type=script&lang=ts"

import "./MdCard.vue?vue&type=style&index=0&id=6d9a965d&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9a965d"]])

export default __exports__